// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"450":"lang-fr-js","822":"lang-messages-js"}[chunkId] + "." + {"450":"bc93bd51","822":"012d7808"}[chunkId] + ".js";
};